import axios from 'axios'
import {
  AllFilter,
  ApprovalTypeFilter,
  TargetTypeFilter,
} from './hooks/useApprovalRuleFilters'
import {
  ApprovalRulePayload,
  PaginatedApprovalRulesResponse,
  PaginatedApprovalRulesResponseSchema,
  PaymentRulesConfig,
  RulesUsageArraySchema,
} from './schema'

export type GetAllRulesParams = {
  program_id: number
  target_type?: TargetTypeFilter
  approval_type?: ApprovalTypeFilter
  is_active?: AllFilter | 0 | 1
  rule_name: string
  records_per_page: number
  page: number
}

export const paymentApprovalApi = {
  updateRule: async (ruleId: number, rule: ApprovalRulePayload) => {
    const response = await axios.put(`/payments/approval_rules/${ruleId}`, rule)
    return response
  },

  getAllRules: async (
    params: GetAllRulesParams
  ): Promise<PaginatedApprovalRulesResponse> => {
    const response = await axios.get('/payments/approval_rules', {
      params: {
        ...params,
      },
    })

    return PaginatedApprovalRulesResponseSchema.parse(response.data)
  },

  bulkUpdateRuleStatus: async (
    ruleIds: number[],
    is_active: boolean,
    programId: number
  ) => {
    const response = await axios.put('/payments/approval_rules/update-status', {
      ids: ruleIds,
      is_active,
      program_id: programId,
    })
    return response
  },

  createRule: async (rule: ApprovalRulePayload) => {
    const response = await axios.post('/payments/approval_rules', rule)
    return response.data
  },

  deleteRule: async (ruleId: number) => {
    return { data: { success: true, message: `Rule ${ruleId} deleted` } }
  },

  getPaymentApprovalRuleApplications: async ({
    programId,
    ruleId,
  }: {
    programId: number
    ruleId: number
  }) => {
    const response = await axios.get('payments/approval_rules/applications', {
      params: {
        program_id: programId,
        records_per_page: 100,
        approval_rule_id: ruleId,
      },
    })

    return RulesUsageArraySchema.parse(response.data.data)
  },

  getApprovalRuleConfig: async () => {
    const response = await axios.get(
      '/payments/approval_rules/configs?with=global_payment_types'
    )
    return PaymentRulesConfig.parse(response.data)
  },
}
